import { __assign, __extends } from "tslib";
import { MDCRipple, MDCRippleFoundation } from '@material/ripple';
import { addClass, getShadowElement } from '@tyler-components-web/core';
import { toggleAttribute, toggleClass } from '../../core';
import { BaseAdapter } from '../../core/adapters';
import { STEP_CONSTANTS } from './step-constants';
var StepAdapter = /** @class */ (function (_super) {
    __extends(StepAdapter, _super);
    function StepAdapter(_component) {
        var _this = _super.call(this, _component) || this;
        _this.unbounded = false;
        _this._buttonElement = getShadowElement(_component, STEP_CONSTANTS.selectors.STEP);
        _this._container = getShadowElement(_component, STEP_CONSTANTS.selectors.STEP_CONTAINER);
        return _this;
    }
    Object.defineProperty(StepAdapter.prototype, "root_", {
        // MDCRippleCapableSurface interface
        get: function () {
            return this._buttonElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepAdapter.prototype, "disabled", {
        get: function () {
            return this._buttonElement.disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepAdapter.prototype, "component", {
        get: function () {
            return this._component;
        },
        enumerable: true,
        configurable: true
    });
    StepAdapter.prototype.setRootTabIndex = function (value) {
        this._buttonElement.tabIndex = value;
    };
    StepAdapter.prototype.initialize = function () {
        this._component.setAttribute('role', 'tab');
    };
    StepAdapter.prototype.attachRipple = function () {
        this._ripple = this.initializeRipple();
    };
    StepAdapter.prototype.detatchRipple = function () {
        if (this._ripple) {
            this._ripple.destroy();
        }
    };
    StepAdapter.prototype.initializeRipple = function () {
        return this._createRipple();
    };
    StepAdapter.prototype.setIndex = function (value) {
        this._buttonElement.querySelector(STEP_CONSTANTS.selectors.INDEX).innerHTML = (value + 1 || '').toString();
    };
    StepAdapter.prototype.toggleRootClass = function (className, on) {
        toggleClass(this._buttonElement, on, className);
    };
    StepAdapter.prototype.setRootAttribute = function (attribute, value) {
        this._buttonElement.setAttribute(attribute, value);
    };
    StepAdapter.prototype.focusButton = function () {
        this._buttonElement.focus();
    };
    StepAdapter.prototype.toggleDisabled = function (disabled) {
        toggleClass(this._buttonElement, disabled, STEP_CONSTANTS.classes.DISABLED);
        toggleAttribute(this._buttonElement, disabled, 'aria-disabled');
        this._buttonElement.disabled = disabled;
    };
    StepAdapter.prototype.toggleIcon = function (name, show) {
        var index = this._buttonElement.querySelector(STEP_CONSTANTS.selectors.INDEX);
        var icon = this._buttonElement.querySelector(STEP_CONSTANTS.selectors.ICON);
        if (!show) {
            index.style.display = 'inherit';
            icon.style.display = 'none';
            return;
        }
        index.style.display = 'none';
        icon.style.display = 'inherit';
        icon.name = name;
    };
    StepAdapter.prototype.slotHasContent = function () {
        return this._expansionSlot.assignedElements({ flatten: true }).length > 0;
    };
    StepAdapter.prototype.setClickListener = function (listener) {
        this._buttonElement.addEventListener('click', listener);
    };
    StepAdapter.prototype.removeClickListener = function (listener) {
        this._buttonElement.removeEventListener('click', listener);
    };
    StepAdapter.prototype.setSlotListener = function (listener) {
        this._expansionSlot.addEventListener('slotchange', listener);
    };
    StepAdapter.prototype.removeSlotListener = function (listener) {
        if (this._expansionSlot) {
            this._expansionSlot.removeEventListener('slotchange', listener);
        }
    };
    StepAdapter.prototype.setExpanded = function (expanded) {
        if (this._expansionPanel) {
            this._expansionPanel.open = expanded;
            toggleAttribute(this._expansionPanel, !expanded, 'tabindex', '-1');
        }
        toggleClass(this._buttonElement, expanded, STEP_CONSTANTS.classes.EXPANDED);
    };
    StepAdapter.prototype.setExpansionPanelAnimations = function (animate) {
        this._expansionPanel.useAnimations = animate;
    };
    StepAdapter.prototype.addExpansionPanel = function () {
        var panel = this._container.querySelector(STEP_CONSTANTS.selectors.EXPANSION_PANEL);
        if (panel) {
            return;
        }
        this._expansionPanel = this._container.appendChild(this._createExpansionPanel());
        this._expansionSlot = this._expansionPanel.querySelector(STEP_CONSTANTS.selectors.EXPANSION_SLOT);
    };
    StepAdapter.prototype.removeExpansionPanel = function () {
        var panel = this._container.querySelector(STEP_CONSTANTS.selectors.EXPANSION_PANEL);
        if (panel) {
            this._container.removeChild(panel);
        }
    };
    StepAdapter.prototype.addExpansionIcon = function () {
        var icon = this._buttonElement.querySelector(STEP_CONSTANTS.selectors.EXPANSION_ICON);
        if (icon) {
            return;
        }
        this._buttonElement.appendChild(this._createExpansionIcon());
    };
    StepAdapter.prototype.removeExpansionIcon = function () {
        var icon = this._buttonElement.querySelector(STEP_CONSTANTS.selectors.EXPANSION_ICON);
        if (icon) {
            this._buttonElement.removeChild(icon);
        }
    };
    StepAdapter.prototype.addExpansionPanelListener = function (event, listener) {
        this._expansionPanel.addEventListener(event, listener);
    };
    StepAdapter.prototype.removeExpansionPanelListener = function (event, listener) {
        if (this._expansionPanel) {
            this._expansionPanel.removeEventListener(event, listener);
        }
    };
    StepAdapter.prototype.isExpandedContentInFocus = function (checkElement) {
        return this._expansionSlot.assignedElements().some(function (element) { return element.contains(checkElement || document.activeElement); });
    };
    StepAdapter.prototype._createRipple = function () {
        var _this = this;
        var adapter = __assign(__assign({}, MDCRipple.createAdapter(this)), { isSurfaceDisabled: function () { return _this._buttonElement.disabled; } });
        var ripple = new MDCRipple(this._buttonElement, new MDCRippleFoundation(adapter));
        return ripple;
    };
    StepAdapter.prototype._createExpansionPanel = function () {
        var panel = document.createElement('tcw-expansion-panel');
        panel.useAnimations = false;
        panel.setAttribute('part', 'expansion-panel');
        addClass(STEP_CONSTANTS.classes.EXPANSION_PANEL, panel);
        var slot = document.createElement('slot');
        slot.setAttribute('name', 'expansion-content');
        addClass(STEP_CONSTANTS.classes.EXPANSION_CONTENT, slot);
        panel.appendChild(slot);
        return panel;
    };
    StepAdapter.prototype._createExpansionIcon = function () {
        var icon = document.createElement('tcw-icon');
        addClass(STEP_CONSTANTS.classes.EXPANSION_ICON, icon);
        icon.name = 'keyboard_arrow_down';
        icon.setAttribute('part', 'expanded-icon');
        return icon;
    };
    return StepAdapter;
}(BaseAdapter));
export { StepAdapter };
